import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from "react-redux";
import './index.css';
import App from './App';
import store from './data/local/store';
 import { ToastContainer } from 'react-toastify';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
  <React.StrictMode>
      <ToastContainer/>
    <Provider store={store}>
    {/* <LocalStorageRetriever keys={['loginProfile', 'verifyBvnProfile', 'fetchSecurityQuestionProfile']} /> */}
    <App />
    </Provider>

  </React.StrictMode>

);


